// This module uses CommonJS so the browser bundle and server-side sitemap generator
// can use the exact same listing slug and canonical path implementation.

/**
 * Create a URL-safe slug from arbitrary text.
 *
 * @param {unknown} value - Value to convert into a slug.
 * @returns {string} URL-safe slug.
 */
const createSlug = value => {
  const base = value != null ? String(value) : '';
  let text = base.toLowerCase().trim();

  const sets = [
    { to: 'a', from: 'ÀÁÂÃÄÅÆĀĂĄẠẢẤẦẨẪẬẮẰẲẴẶ' },
    { to: 'c', from: 'ÇĆĈČ' },
    { to: 'd', from: 'ÐĎĐÞ' },
    { to: 'e', from: 'ÈÉÊËĒĔĖĘĚẸẺẼẾỀỂỄỆ' },
    { to: 'g', from: 'ĜĞĢǴ' },
    { to: 'h', from: 'ĤḦ' },
    { to: 'i', from: 'ÌÍÎÏĨĪĮİỈỊ' },
    { to: 'j', from: 'Ĵ' },
    { to: 'ij', from: 'Ĳ' },
    { to: 'k', from: 'Ķ' },
    { to: 'l', from: 'ĹĻĽŁ' },
    { to: 'm', from: 'Ḿ' },
    { to: 'n', from: 'ÑŃŅŇ' },
    { to: 'o', from: 'ÒÓÔÕÖØŌŎŐỌỎỐỒỔỖỘỚỜỞỠỢǪǬƠ' },
    { to: 'oe', from: 'Œ' },
    { to: 'p', from: 'ṕ' },
    { to: 'r', from: 'ŔŖŘ' },
    { to: 's', from: 'ßŚŜŞŠ' },
    { to: 't', from: 'ŢŤ' },
    { to: 'u', from: 'ÙÚÛÜŨŪŬŮŰŲỤỦỨỪỬỮỰƯ' },
    { to: 'w', from: 'ẂŴẀẄ' },
    { to: 'x', from: 'ẍ' },
    { to: 'y', from: 'ÝŶŸỲỴỶỸ' },
    { to: 'z', from: 'ŹŻŽ' },
    { to: '-', from: "·/_,:;'" },
  ];

  sets.forEach(set => {
    text = text.replace(new RegExp(`[${set.from}]`, 'gi'), set.to);
  });

  const slug = encodeURIComponent(
    text
      .replace(/\s+/g, '-')
      .replace(/[^\w-]+/g, '')
      .replace(/--+/g, '-')
      .replace(/^-+/, '')
      .replace(/-+$/, '')
  );

  return slug.length > 0 ? slug : 'no-slug';
};

/**
 * Construct the canonical path for a public listing.
 *
 * @param {unknown} title - Current fetched listing title.
 * @param {string|{uuid: string}} listingId - Listing UUID or SDK UUID instance.
 * @returns {string} Canonical listing path without query string or fragment.
 */
const createListingCanonicalPath = (title, listingId) => {
  const id = listingId?.uuid || listingId;
  if (!id) {
    throw new TypeError('A listing ID is required to create a canonical path.');
  }

  return `/l/${createSlug(title)}/${id}`;
};

module.exports = { createSlug, createListingCanonicalPath };
